import viewMessage from "./viewMessage";
import standaloneFeedback from "./standaloneFeedback";

export default [viewMessage, standaloneFeedback];
